import type { PaginationParams } from '@/types/ApiTypes';
import { useCallback, useState } from 'react';

interface UsePaginationReturn {
  pagination: PaginationParams;
  setPagination: (params: Partial<PaginationParams>) => void;
  setPage: (page: number) => void;
  setPageSize: (size: number) => void;
  reset: () => void;
}

export const usePagination = (
  initialPage: number = 1,
  initialPageSize: number = 20
): UsePaginationReturn => {
  const [pagination, setPaginationState] = useState<PaginationParams>({
    pageNumber: initialPage,
    pageSize: initialPageSize,
  });

  const setPagination = useCallback((params: Partial<PaginationParams>) => {
    setPaginationState(prev => ({ ...prev, ...params }));
  }, []);

  const setPage = useCallback((page: number) => {
    setPaginationState(prev => ({ ...prev, pageNumber: page }));
  }, []);

  const setPageSize = useCallback((size: number) => {
    setPaginationState(prev => ({ ...prev, pageSize: size, pageNumber: 1 }));
  }, []);

  const reset = useCallback(() => {
    setPaginationState({
      pageNumber: initialPage,
      pageSize: initialPageSize,
    });
  }, [initialPage, initialPageSize]);

  return {
    pagination,
    setPagination,
    setPage,
    setPageSize,
    reset,
  };
};